import { Inject, Injectable } from 'ng-metadata/core';
import * as angular from 'angular';

/**
 * @ngdoc service
 * @name mwCSDisplayOptionsService
 * @module mw.components.contentStream
 * @description
 * A service that is used to open display options in a modal
 */

 /**
  * @ngdoc method
  * @name mwCSDisplayOptionsService#openDisplayOptions
  * @param {Object} event - targetEvent for $mdDialog
  * @param {Object} displayOptions - Object containing all the different types of display options
  * @param {Object} parentElement - Parent DOM element for $mdDialog
  *
  * @returns {Object} - A modified version of the display options based on your selections
  */
@Injectable()
export class DisplayOptionsService {
    displayOptions;

    constructor(
        @Inject('$mdDialog') private $mdDialog,
        @Inject('$translate') private $translate
    ) {}

    handleOk(displayOptions) {
        this.$mdDialog.hide(displayOptions);
    }

    handleCancel() {
        this.$mdDialog.cancel();
    }

    openDisplayOptions(event, displayOptions, parentElement) {
        return this.$mdDialog.show({
            autoWrap: false,
            bindToController: true,
            controller: () => {
                'ngInject';
            },
            controllerAs: '$ctrl',
            fullscreen: true,
            locals: {
                handleCancel: this.handleCancel,
                handleOk: this.handleOk,
                $mdDialog: this.$mdDialog,
                displayOptions: angular.copy(displayOptions)
            },
            multiple: true,
            parent: parentElement,
            targetEvent: event,
            template: `
                    <md-dialog class="mw-mini-modal" aria-label="Display Options" layout="column">
                        <mw-mini-modal-dialog class="mw-mini-modal-dialog" ok="{{'OK' | translate}}" cancel="{{'Cancel' | translate}}" no-padding="true" title="{{'mw-content-stream-display-options__dialog--title' | translate}}" layout="column" on-cancel="$ctrl.handleCancel()" on-ok="$ctrl.handleOk($ctrl.displayOptions)">
                            <mw-modal-content>
                                <mw-content-stream-display-options
                                    display-options="$ctrl.displayOptions">
                                </mw-content-stream-display-options>
                            </mw-modal-content>
                        </mw-mini-modal-dialog>
                    </md-dialog>
                `
            });
        }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-stream/display-options/display-options.service.ts